<template>
  <a class="ew-call-float" href="tel:3317547337" aria-label="Llámanos">
    <img src="@/assets/images/call-answer.png" alt="">
  </a>
</template>

<script>
export default {
  name: 'CallFloatButton'
}
</script>

<style scoped lang="scss">
.ew-call-float {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 40;
  bottom: 2rem;
  left: 1.5rem;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: #0057ba;
  box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);

  img { width: 28px; height: auto; }
}

@media (max-width: 767px) {
  .ew-call-float {
    bottom: 1.2rem;
    left: 1.4rem;
    width: 48px;
    height: 48px;
    img { width: 22px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/CallFloatButton.vue